export class ParametroListaCpfs {
	lista_cpfs!: string[];
}
